<div class="settings-panel" data-testid="allo-settings">
  @if (loading()) {
    <div class="settings-loading" data-testid="allo-settings-loading">
      <mat-spinner diameter="20"></mat-spinner>
    </div>
  } @else {
    <section class="settings-section">
      <div class="settings-row">
        <div class="settings-row__text">
          <h3 class="settings-title">{{ 'GNR_ALLO_MEMORY' | translate }}</h3>
          <p class="settings-description">
            {{ 'GNR_ALLO_MEMORY_DESC' | translate }}
          </p>
        </div>
        <mat-slide-toggle
          class="settings-toggle"
          data-testid="allo-settings-memory-toggle"
          [checked]="!memoryOptOut()"
          [disabled]="saving()"
          (change)="toggleOptOut(!$event.checked)">
        </mat-slide-toggle>
      </div>

      @if (memoryOptOut()) {
        <p class="settings-opted-out" data-testid="allo-settings-opted-out">
          {{ 'GNR_ALLO_MEMORY_OFF_HINT' | translate }}
        </p>
      }
    </section>

    <section class="settings-section">
      <div class="settings-row">
        <div class="settings-row__text">
          <h3 class="settings-title">
            {{ 'GNR_ALLO_MEMORY_STORED' | translate }}
          </h3>
        </div>
        @if (summary()) {
          <button
            class="settings-clear-btn"
            type="button"
            data-testid="allo-settings-clear"
            [disabled]="saving()"
            (click)="confirmClear()"
            [attr.aria-label]="'GNR_ALLO_MEMORY_CLEAR' | translate"
            [matTooltip]="'GNR_ALLO_MEMORY_CLEAR_TOOLTIP' | translate"
            matTooltipPosition="below">
            <mat-icon>delete</mat-icon>
            <span>{{ 'GNR_ALLO_MEMORY_CLEAR' | translate }}</span>
          </button>
        }
      </div>

      @if (summary(); as storedSummary) {
        <pre class="settings-summary" data-testid="allo-settings-summary">{{
          storedSummary
        }}</pre>
      } @else {
        <p class="settings-empty" data-testid="allo-settings-empty">
          {{ 'GNR_ALLO_MEMORY_EMPTY' | translate }}
        </p>
      }

      <p class="settings-hint" data-testid="allo-settings-hint">
        <mat-icon class="settings-hint__icon">lightbulb</mat-icon>
        <span>{{ 'GNR_ALLO_MEMORY_UPDATE_HINT' | translate }}</span>
      </p>
    </section>

    @if (error(); as errorKey) {
      <p class="settings-error" role="alert" data-testid="allo-settings-error">
        {{ errorKey | translate }}
      </p>
    }
  }
</div>
